import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import Truncate from 'react-truncate';
import { sendProductImpression } from '../AdMind/impressionProduct';

const getVariantFromColorAndSize = (variants, color, size) => {
  const filteredVariants = variants.filter((variant) => {
    return variant.option1 === color && variant.inventory !== '0';
  });

  const sizeMatch = filteredVariants.find((variant) => variant.option2 === size);

  if (sizeMatch) {
    return sizeMatch;
  }

  return filteredVariants.length > 0 ? filteredVariants[0] : variants[0];
};

const ProductTileAlternate = (props) => {
  const availableVariants = props.variants.filter((variant) => {
    return variant.available || variant.inventory > 0;
  });

  // Don't show if there are no available variants
  if (availableVariants.length === 0) {
    return null;
  }
  const adMindProduct = {
    compare_at_price: props.product.compare_at_price,
    id: props.product.product_id,
    type: props.product.product_type,
    title: props.product.Title,
    tags: props.product.tags,
  };

  const productUrl = props.collectionUrl ? `${props.collectionUrl}${props.product_url}` : `${props.product_url}`;

  const [selectedVariant, setSelectedVariant] = useState(availableVariants[0]);
  const [currentThumbUrl, setCurentThumbUrl] = useState(availableVariants[0].thumb_url);
  const [productUrlState, setProductUrlState] = useState(props.product_url);

  const availableColors = props.colorOptions.filter((color) => {
    const availableVariantsWithColor = availableVariants.filter((variant) => {
      return variant.option1 === color;
    });

    return availableVariantsWithColor.length > 0;
  });

  const [selectedColor, setSelectedColor] = useState(availableColors[0]);

  const availableSizes = availableVariants.filter((variant) => {
    return variant.option1 === selectedColor;
  });

  const [selectedSize, setSelectedSize] = useState(availableSizes[0].option2);

  const colorSelectEl = useRef(null);
  const sizeSelectEl = useRef(null);

  const colorChangeHandler = (e) => {
    sendProductImpression(selectedVariant, adMindProduct);
    setSelectedColor(e.target.value);
  };

  const sizeChangeHandler = (e) => {
    sendProductImpression(selectedVariant, adMindProduct);
    setSelectedSize(e.target.value);
  };

  const productTileClasses = classNames({
    ProductTile: true,
    ProductTileAlternate: true,
    'ProductTile--react': true,
  });

  const badges = props.tags
    .filter((tag) => {
      return tag.indexOf('Badge - ') > -1;
    })
    .map((tag) => {
      return tag.replace('Badge - ', '');
    });

  useEffect(() => {
    colorSelectEl.current.addEventListener('change', colorChangeHandler);
    sizeSelectEl.current.addEventListener('change', sizeChangeHandler);

    return () => {
      colorSelectEl.current.removeEventListener('change', colorChangeHandler);
      sizeSelectEl.current.removeEventListener('change', sizeChangeHandler);
    };
  }, [selectedVariant]);

  useEffect(() => {
    const size = sizeSelectEl.current.value;
    const color = colorSelectEl.current.value;
    const currentVariant = getVariantFromColorAndSize(props.variants, color, size);

    setSelectedVariant(currentVariant);
  }, [selectedColor, selectedSize]);

  useEffect(() => {
    setCurentThumbUrl(selectedVariant.image_url);
    var newURL = new URL(productUrlState);
    newURL.searchParams.set('variant', selectedVariant.variant_id);
    setProductUrlState(newURL.href);
  }, [selectedVariant]);

  useEffect(() => {
    let newProductUrl = productUrlState.replace('https://www.windsorstore.com', `https://${window.location.hostname}`);
    setProductUrlState(newProductUrl);
  }, [productUrlState]);

  const currency_symbol = window.theme.currency_symbol ? window.theme.currency_symbol : '$';
  const currency_iso = window.theme.currency_iso ? window.theme.currency_iso : 'USD';
  const currency_alternate_iso =
    currency_symbol === '$' && currency_iso !== 'USD' && currency_iso !== 'HKD' ? currency_iso : '';

  return (
    <div className={productTileClasses} data-product-tile>
      {currentThumbUrl && (
        <a
          className="ProductTileAlternate__image"
          href={[productUrlState]}
          data-product-tile-image
          title={props.title}
          data-product-id={props.id}
          target="_self"
        >
          <img
            alt={props.id}
            src={`${currentThumbUrl
              .replace('.jpg', '_300x400_crop_center.jpg')
              .replace('.webp', '_300x400_crop_center.webp')}`}
            data-product-id={props.id}
          />
          {badges.length > 0 && <div className="ProductTile__badge">{badges[0]}</div>}
        </a>
      )}

      <div className="ProductTileAlternate__info">
        <p className="ProductTileAlternate__title" data-product-tile-title>
          <a href={productUrlState} data-product-id={props.id}>
            <Truncate lines={2}>{props.title}</Truncate>
          </a>
        </p>

        {selectedVariant.price_compare_max > selectedVariant.price ? (
          <p className="ProductTileAlternate__price ProductTileAlternate__price--sale">
            <span data-product-id={props.id} className="sale">
              {currency_alternate_iso}
              {window.formatter.format(selectedVariant.price)} - {currency_alternate_iso}
              {window.formatter.format(selectedVariant.price_compare_max)}
            </span>
            <span data-product-id={props.id} className="discount">
              (
              {Math.round(
                ((selectedVariant.price_compare_max - selectedVariant.price) / selectedVariant.price_compare_max) * 100,
              )}
              % off)
            </span>
          </p>
        ) : (
          <p className="ProductTileAlternate__price" data-product-id={props.id} data-product-tile-price>
            {currency_alternate_iso}
            {window.formatter.format(selectedVariant.price)}
          </p>
        )}
      </div>

      <div className="ProductTileAlternate__options">
        <div className="ProductTileAltenate__variant">
          <div>
            {availableColors && (
              <select ref={colorSelectEl}>
                {availableColors.map((value, i) => {
                  return (
                    <option data-product-id={props.id} key={`colorOption-${value}-${i}`} value={value}>
                      {value}
                    </option>
                  );
                })}
              </select>
            )}
          </div>
        </div>
        <div className="ProductTileAltenate__variant">
          <div>
            {availableSizes && (
              <select ref={sizeSelectEl}>
                {availableSizes.map((value, index) => {
                  return (
                    <option key={`sizeOption-${value.option2}-${index}`} value={value.option2}>
                      {value.option2}
                    </option>
                  );
                })}
              </select>
            )}
          </div>
        </div>
      </div>

      <form
        action="/cart/add"
        method="post"
        encType="multipart/form-data"
        data-product-id={props.id}
        data-pid={selectedVariant.variant_id}
        data-is-rec={props.isRec}
        data-section-type="product"
      >
        <input type="hidden" name="id" value={selectedVariant.variant_id} />
        <input type="hidden" name="quantity" value="1" />
        <input type="hidden" name="properties[pid]" value={props.pid} />
        <button
          type="submit"
          name="add"
          className="ProductTileAlternate__button Button Button--primary"
          data-add-to-cart
        >
          <span data-add-to-cart-text>+ Add To Bag</span>
        </button>
        <script type="application/json" data-product-json data-tile-type="certona">
          {JSON.stringify(props)}
        </script>
      </form>
    </div>
  );
};

ProductTileAlternate.defaultProps = {
  title: 'No title provided',
  styleNumbers: {},
  variants: [],
  options: [],
  images: [],
  pid: '',
  isRec: false,
};

export default ProductTileAlternate;
